import { Checkbox } from 'antd'
import { CheckboxValueType } from 'antd/es/checkbox/Group'
import { capitalizeFirstLetter } from 'helper/utility'
import React from 'react'
import { creationEventStore } from 'state/event/eventCreationStore'
import { EventResp } from 'types/event/events'
import { RecepientToSend } from 'types/event/eventStep5'

interface TicketsRecepientProps {
  recepientPayload: RecepientToSend
  setRecepientPayload: React.Dispatch<React.SetStateAction<RecepientToSend>>
}

const TicketsRecepient: React.FC<TicketsRecepientProps> = ({
  recepientPayload,
  setRecepientPayload,
}) => {
  const { eventData }: { eventData: EventResp } = creationEventStore(store => ({
    eventData: store.eventData,
  }))

  const hanldeAdmissionChange = (checkedValues: CheckboxValueType[]) => {
    setRecepientPayload({
      ...recepientPayload,
      admissionTicketIds: checkedValues as string[],
    })
  }

  const hanldeAdditionalChange = (checkedValues: CheckboxValueType[]) => {
    setRecepientPayload({
      ...recepientPayload,
      additionalOptionIds: checkedValues as string[],
    })
  }

  const hanldeDropInChange = (checkedValues: CheckboxValueType[]) => {
    setRecepientPayload({
      ...recepientPayload,
      dropInTicketIds: checkedValues as string[],
    })
  }

  return (
    <div className="h-13 scoller overflow-auto-y">
      <div className="mt-20px">
        <div>
          <h3 className="text-16 w-600 mb-10px">Admission Tickets</h3>
          {eventData.admissionTickets.length > 0 ? (
            <Checkbox.Group
              onChange={hanldeAdmissionChange}
              className="d-flex flex flex-column flex-wrap gap-10"
              value={recepientPayload.admissionTicketIds}
            >
              {eventData.admissionTickets.map(ticket => (
                <Checkbox
                  value={ticket._id}
                  key={ticket._id}
                  className="kids-listing-auth-adults"
                >
                  <p>{capitalizeFirstLetter(ticket.name)}</p>
                </Checkbox>
              ))}
            </Checkbox.Group>
          ) : (
            <p className="mt-20px">No tickets found</p>
          )}
        </div>

        <div className="mt-20px">
          <h3 className="text-16 w-600 mb-10px">Additional option Tickets</h3>
          {eventData.additionalOptions.length > 0 ? (
            <Checkbox.Group
              onChange={hanldeAdditionalChange}
              className="d-flex flex flex-column flex-wrap gap-10"
              value={recepientPayload.additionalOptionIds}
            >
              {eventData.additionalOptions.map(ticket => (
                <Checkbox
                  value={ticket._id}
                  key={ticket._id}
                  className="kids-listing-auth-adults"
                >
                  <p>{capitalizeFirstLetter(ticket.name)}</p>
                </Checkbox>
              ))}
            </Checkbox.Group>
          ) : (
            <p className="mt-20px">No tickets found</p>
          )}
        </div>

        <div className="mt-20px">
          <h3 className="text-16 w-600 mb-10px">Drop-in Tickets</h3>
          {eventData.dropInTicket ? (
            <Checkbox.Group
              onChange={hanldeDropInChange}
              className="d-flex flex flex-column flex-wrap gap-10"
              value={recepientPayload.dropInTicketIds}
            >
              <Checkbox
                value={eventData.dropInTicket._id}
                key={eventData.dropInTicket._id}
                className="kids-listing-auth-adults"
              >
                <p>{capitalizeFirstLetter(eventData.dropInTicket.name)}</p>
              </Checkbox>
            </Checkbox.Group>
          ) : (
            <p className="mt-20px">No tickets found</p>
          )}
        </div>
      </div>
    </div>
  )
}

export default TicketsRecepient
